module.exports = __webpack_public_path__ + "static/media/Apr_2026_1.fab15cc0.webp";